import React, { useState, useEffect, useContext } from 'react';
import _get from 'lodash/get';
import cn from 'classnames';

import { UiKit } from 'components';
import { TableSearch } from 'components/Tables';
import { ReactTablesContext } from 'components/ReactTable';

export default function ExplicitSearch({
  customClass = '',
  inputRef = null,
  placeholder = 'Search',
  onReady = () => {},
  hideButton = false,
  ...inputProps
}) {
  const { refine, clearRefinement, refinements } = useContext(
    ReactTablesContext
  );

  const searchValue = _get(refinements, 'search', '');
  const [value, setValue] = useState(searchValue);

  useEffect(() => {
    setValue(searchValue);
  }, [searchValue]);

  useEffect(() => {
    onReady();
    // eslint-disable-next-line
  }, []);

  const submitHandler = e => {
    e.preventDefault();
    const { onBlur = () => {} } = inputProps;
    const callbackFunc = !value ? clearRefinement : refine;
    onBlur();
    callbackFunc({ attribute: 'search', type: 'search', value });
  };

  const onCrossIconClick = () => {
    const value = '';
    setValue(value);
    if (searchValue) {
      clearRefinement({ attribute: 'search', type: 'search', value });
    }
  };

  return (
    <form className={cn('table-search', customClass)} onSubmit={submitHandler}>
      <TableSearch
        inputRef={inputRef}
        value={value}
        onChange={setValue}
        onCancel={onCrossIconClick}
        placeholder={placeholder}
        {...inputProps}
      />
      {!hideButton && (
        <UiKit.Button variant="outline" className="table-filter-button">
          Search
        </UiKit.Button>
      )}
    </form>
  );
}
